import { useContext, useEffect, useRef, useState } from 'react';
import OffersCard from '../../../components/offersCard/OffersCard';
import './offers.css';
import { OffersContext } from '../../../context/OffersContext';
import { json, useNavigate } from 'react-router-dom';
import MobileOffferSection from './mobileOffer/MobileOffferSection';
import { getOffersData } from '../../../api/infoAPI';

const OffersSection = () => {
    const offerCardRef = useRef(null);
    const cardsPerSlide = 3;
    const { setIsOfferPopupOpen, setSelectedOfferId } = useContext(OffersContext);
    const navigate = useNavigate();
    const [offersData, setOffersData] = useState([]);
    const [loading, setLoading] = useState(false);

    let slideWidth;
    if (offerCardRef.current) {
        const containerWidth = offerCardRef.current.scrollWidth;
        slideWidth = containerWidth / Math.ceil(offerCardRef.current.children.length / cardsPerSlide);
    }

    const scrollLeft = () => {
        if (offerCardRef.current) {
            offerCardRef.current.scrollBy({
                left: -slideWidth,
                behavior: 'smooth'
            });
        }
    };

    const scrollRight = () => {
        if (offerCardRef.current) {
            offerCardRef.current.scrollBy({
                left: slideWidth,
                behavior: 'smooth'
            });
        }
    };

    const fetchOffer = async () => {
        setLoading(true);
        try {
            const offerResponse = await getOffersData();
            setOffersData(offerResponse.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error('Error fetching offers:', error);
        }
    };

    useEffect(() => {
        fetchOffer();
    }, []);

    const handleOfferCardClick = (id) => {
        setSelectedOfferId(id);
        setIsOfferPopupOpen(true);
        navigate('/offers');
    };

    return (
        <>
            <div className='offersBg' />
            <div className='offersSection customContainer' id='offersSection'>
                <div className='offerSectionTextContainer'>
                    <div>
                        <p className='pageCount'>Offers</p>
                        <p className='homeTitle'>Unlock Exciting Travel Offers</p>
                    </div>
                </div>
                <div className='offerCardContainer mobOfferHidden' ref={offerCardRef}>
                    {offersData?.map((offerItem) => (
                        <OffersCard
                            key={offerItem._id}
                            offersData={offerItem}
                            scrollLeft={scrollLeft}
                            scrollRight={scrollRight}
                            handleOfferCardClick={() => handleOfferCardClick(offerItem._id)}
                        />
                    ))}
                </div>
                <div className='mobOfferDisplay'>
                    <MobileOffferSection data={offersData} />
                </div>
            </div>
        </>
    );
};

export default OffersSection;
